export default __webpack_public_path__ + "static/AppMoneyWalkie6-ea6494285bdf58b08e892dae0153975c.png";